
export const SET_GRIDVIEW = "SET_GRIDVIEW";
export const SET_LISTVIEW = "SET_LISTVIEW";
export const UPDATE_SORT = "UPDATE_SORT";
export const SORT_DISH = "SORT_DISH";
export const UPDATE_FILTERS = "UPDATE_FILTERS";
export const FILTER_DISH = "FILTER_DISH";
export const CLEAR_FILTERS = "CLEAR_FILTERS";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_CART_ITEM = "REMOVE_CART_ITEM";
export const TOGGLE_CART_ITEM_AMOUNT = "TOGGLE_CART_ITEM_AMOUNT";
export const CLEAR_CART = "CLEAR_CART";
export const COUNT_CART_TOTALS = "COUNT_CART_TOTALS";
export const GET_USER_BEGIN = "GET_USER_BEGIN";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_ERROR = "GET_USER_ERROR";
export const GET_CURRENT_USER_BEGIN = "GET_CURRENT_USER_BEGIN";
export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER_ERROR = "GET_CURRENT_USER_ERROR";
export const GET_SINGLE_USER_BEGIN = "GET_SINGLE_USER_BEGIN";
export const GET_SINGLE_USER_SUCCESS = "GET_SINGLE_USER_SUCCESS";
export const GET_SINGLE_USER_ERROR = "GET_SINGLE_USER_ERROR";
export const GET_USER_FILES_BEGIN = "GET_USER_FILES_BEGIN";
export const GET_USER_FILES_SUCCESS = "GET_USER_FILES_SUCCESS";
export const GET_USER_FILES_ERROR = "GET_USER_FILES_ERROR";
export const GET_SINGLE_USER_FILES_BEGIN = "GET_SINGLE_USER_FILES_BEGIN";
export const GET_SINGLE_USER_FILES_SUCCESS = "GET_SINGLE_USER_FILES_SUCCESS";
export const GET_SINGLE_USER_FILES_ERROR = "GET_SINGLE_USER_FILES_ERROR";
export const GET_SINGLE_FILE_BEGIN = "GET_SINGLE_FILE_BEGIN";
export const GET_SINGLE_FILE_SUCCESS = "GET_SINGLE_FILE_SUCCESS";
export const GET_SINGLE_FILE_ERROR = "GET_SINGLE_FILE_ERROR";
export const GET_FILES_BEGIN = "GET_FILES_BEGIN";
export const GET_FILES_SUCCESS = "GET_FILES_SUCCESS";
export const GET_FILES_ERROR = "GET_FILES_ERROR";
export const FILE_UPLOAD_BEGIN = "FILE_UPLOAD_BEGIN";
export const FILE_UPLOAD_SUCCESS = "FILE_UPLOAD_SUCCESS";
export const FILE_UPLOAD_ERROR = "FILE_UPLOAD_ERROR";
export const UPDATE_SEARCH_VALUE = "UPDATE_SEARCH_VALUE";
export const FILTER_FILES = "FILTER_FILES";